// extracted by mini-css-extract-plugin
export default {"number":"orders_number__aTYWi","currency":"orders_currency__ATF+3","header":"orders_header__4SrZT","removeButton":"orders_removeButton__8uS2G"};